import { Socket } from "phoenix"

let socket = new Socket(import.meta.env.VITE_TRACKER_SOCKET, {
    params: { token: window.userToken }
})
export default socket

